export function getFunctorComposition(F, G) {
    return {
        map: function (fa, f) { return F.map(fa, function (ga) { return G.map(ga, f); }); }
    };
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/fp-ts/es6/Functor.js
// module id = 84
// module chunks = 12